import i18n from "../i18n";
import { FEATURE_402_MESSAGE } from "./planState";

/**
 * In-page upgrade handler for buttons/mutations that 402 when the company's
 * plan doesn't include the feature. Design rule: never hide the button — on a
 * 402 we keep it visible and surface an upsell toast instead.
 *
 * `showToast` is the function from useCustomToast() (PrimeReact Toast), passed
 * in by the calling component since this helper lives outside React.
 *
 * Returns true when it handled a 402 (so callers can stop), false otherwise so
 * the caller falls through to its normal error handling.
 */
export function onUpgrade402(error, showToast) {
  if (error?.response?.status !== 402) return false;

  // The backend's feature_disabled text is English; show the localized copy instead.
  // Any other 402 message is passed through untouched.
  const message = error.response.data?.message;
  const detail =
    !message || message === FEATURE_402_MESSAGE
      ? i18n.t("feature_unavailable.upgrade_toast_body")
      : message;

  if (typeof showToast === "function") {
    showToast("warn", i18n.t("feature_unavailable.upgrade_toast_title"), detail);
  }

  return true;
}

export default onUpgrade402;
